import { render, staticRenderFns } from "./Refund8ConfirmPage.vue?vue&type=template&id=67e3a964"
import script from "./Refund8ConfirmPage.vue?vue&type=script&lang=js"
export * from "./Refund8ConfirmPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports